import { InjectionToken } from '@angular/core';

export class InjectionTokens {
  public static readonly MUTATION_OBSERVER = new InjectionToken('MutationObserver', {
    providedIn: 'root',
    factory: () => MutationObserver,
  });

  public static readonly WINDOW = new InjectionToken('Window', {
    providedIn: 'root',
    factory: () => window,
  });

  public static readonly LOCATION = new InjectionToken('Location', {
    providedIn: 'root',
    factory: () => location,
  });
}
